/**
 * Cheap detection of KMD text (for paste/drop routing) — mirrors the mermaid
 * sniffer's philosophy: fast, permissive, false-positives resolved by the
 * parser itself.
 */
export const isMaybeKmd = (text: string): boolean =>
  /^﻿?\s*---\r?\n(?:[^\n]*\r?\n){0,20}?\s*khiyarsa\s*:\s*\d+/m.test(
    text.slice(0, 2000),
  );
